let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("la8cf")).then(() => parcelRequire('9B1xP'));